/**
 * @generated SignedSource<<f23634c2331577a69178396b2ec271b6>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type AdminMembersReportSurveysTableQuery$variables = {
  after?: string | null;
  before?: string | null;
  first?: number | null;
  id: string;
  last?: number | null;
  memberOrganizationMembershipId: string;
};
export type AdminMembersReportSurveysTableQuery$data = {
  readonly node: {
    readonly id?: string;
    readonly " $fragmentSpreads": FragmentRefs<"AdminMembersReportSurveysTable_PaginationFragment">;
  } | null;
};
export type AdminMembersReportSurveysTableQuery = {
  response: AdminMembersReportSurveysTableQuery$data;
  variables: AdminMembersReportSurveysTableQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "after"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "before"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "first"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "id"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "last"
},
v5 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "memberOrganizationMembershipId"
},
v6 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "id"
  }
],
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v8 = {
  "kind": "Variable",
  "name": "after",
  "variableName": "after"
},
v9 = {
  "kind": "Variable",
  "name": "before",
  "variableName": "before"
},
v10 = {
  "kind": "Variable",
  "name": "contentUsageId",
  "variableName": "id"
},
v11 = {
  "kind": "Variable",
  "name": "first",
  "variableName": "first"
},
v12 = {
  "kind": "Variable",
  "name": "last",
  "variableName": "last"
},
v13 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v14 = [
  (v8/*: any*/),
  (v9/*: any*/),
  (v11/*: any*/),
  (v12/*: any*/)
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/),
      (v5/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "AdminMembersReportSurveysTableQuery",
    "selections": [
      {
        "alias": null,
        "args": (v6/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "kind": "InlineFragment",
            "selections": [
              (v7/*: any*/),
              {
                "args": [
                  (v8/*: any*/),
                  (v9/*: any*/),
                  (v10/*: any*/),
                  (v11/*: any*/),
                  (v12/*: any*/),
                  {
                    "kind": "Variable",
                    "name": "memberOrganizationMembershipId",
                    "variableName": "memberOrganizationMembershipId"
                  }
                ],
                "kind": "FragmentSpread",
                "name": "AdminMembersReportSurveysTable_PaginationFragment"
              }
            ],
            "type": "ContentUsage",
            "abstractKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v3/*: any*/),
      (v2/*: any*/),
      (v0/*: any*/),
      (v4/*: any*/),
      (v1/*: any*/),
      (v5/*: any*/)
    ],
    "kind": "Operation",
    "name": "AdminMembersReportSurveysTableQuery",
    "selections": [
      {
        "alias": null,
        "args": (v6/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          (v13/*: any*/),
          (v7/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "Content",
                "kind": "LinkedField",
                "name": "content",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "WebForm",
                    "kind": "LinkedField",
                    "name": "webForm",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "WebFormRevision",
                        "kind": "LinkedField",
                        "name": "currentRevision",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": (v14/*: any*/),
                            "concreteType": "WebFormQuestionNodeConnection",
                            "kind": "LinkedField",
                            "name": "questions",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "totalCount",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "WebFormQuestionNodeEdge",
                                "kind": "LinkedField",
                                "name": "edges",
                                "plural": true,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "cursor",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "WebFormQuestion",
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": [
                                      (v7/*: any*/),
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "type",
                                        "storageKey": null
                                      },
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "richEditorBody",
                                        "storageKey": null
                                      },
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "WebFormQuestionOption",
                                        "kind": "LinkedField",
                                        "name": "options",
                                        "plural": true,
                                        "selections": [
                                          (v7/*: any*/),
                                          {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "label",
                                            "storageKey": null
                                          }
                                        ],
                                        "storageKey": null
                                      },
                                      {
                                        "alias": null,
                                        "args": [
                                          (v10/*: any*/),
                                          {
                                            "kind": "Variable",
                                            "name": "organizationMembershipId",
                                            "variableName": "memberOrganizationMembershipId"
                                          }
                                        ],
                                        "concreteType": "WebFormAnswer",
                                        "kind": "LinkedField",
                                        "name": "answer",
                                        "plural": false,
                                        "selections": [
                                          {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "isSkipped",
                                            "storageKey": null
                                          },
                                          {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "body",
                                            "storageKey": null
                                          },
                                          {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "selectedOptions",
                                            "storageKey": null
                                          },
                                          (v7/*: any*/)
                                        ],
                                        "storageKey": null
                                      },
                                      (v13/*: any*/)
                                    ],
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "PageInfoObjectType",
                                "kind": "LinkedField",
                                "name": "pageInfo",
                                "plural": false,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "endCursor",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "startCursor",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "hasNextPage",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "hasPreviousPage",
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": (v14/*: any*/),
                            "filters": null,
                            "handle": "connection",
                            "key": "AdminMembersReportSurveysTable_questions",
                            "kind": "LinkedHandle",
                            "name": "questions"
                          },
                          (v7/*: any*/)
                        ],
                        "storageKey": null
                      },
                      (v7/*: any*/)
                    ],
                    "storageKey": null
                  },
                  (v7/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "type": "ContentUsage",
            "abstractKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "ae8ccbd7ef9f9a14ae3f043412e4385a",
    "id": null,
    "metadata": {},
    "name": "AdminMembersReportSurveysTableQuery",
    "operationKind": "query",
    "text": "query AdminMembersReportSurveysTableQuery(\n  $id: ID!\n  $first: Int\n  $after: String\n  $last: Int\n  $before: String\n  $memberOrganizationMembershipId: ID!\n) {\n  node(id: $id) {\n    __typename\n    ... on ContentUsage {\n      id\n      ...AdminMembersReportSurveysTable_PaginationFragment_yTDXF\n    }\n    id\n  }\n}\n\nfragment AdminMembersReportSurveysTableRowFragment_1dFmbB on WebFormQuestion {\n  ...WebFormQuestionTypeTableFieldFragment\n  ...WebFormQuestionTableFieldFragment\n  ...WebFormQuestionResponseTableFieldFragment_1dFmbB\n}\n\nfragment AdminMembersReportSurveysTable_PaginationFragment_yTDXF on ContentUsage {\n  id\n  content {\n    webForm {\n      currentRevision {\n        questions(first: $first, after: $after, last: $last, before: $before) {\n          totalCount\n          edges {\n            cursor\n            node {\n              id\n              ...AdminMembersReportSurveysTableRowFragment_1dFmbB\n              __typename\n            }\n          }\n          pageInfo {\n            endCursor\n            startCursor\n            hasNextPage\n            hasPreviousPage\n          }\n        }\n        id\n      }\n      id\n    }\n    id\n  }\n}\n\nfragment WebFormQuestionResponseTableFieldFragment_1dFmbB on WebFormQuestion {\n  type\n  options {\n    id\n    label\n  }\n  answer(organizationMembershipId: $memberOrganizationMembershipId, contentUsageId: $id) {\n    isSkipped\n    body\n    selectedOptions\n    id\n  }\n}\n\nfragment WebFormQuestionTableFieldFragment on WebFormQuestion {\n  richEditorBody\n}\n\nfragment WebFormQuestionTypeTableFieldFragment on WebFormQuestion {\n  type\n  richEditorBody\n  options {\n    id\n    label\n  }\n}\n"
  }
};
})();

(node as any).hash = "cadc62337d62f3a3c7f3cd12c46602a7";

export default node;
